import React from 'react'

import styles from '../component-styles/get-started-panel.module.scss'

export default function GetStartedPanel(): React.ReactElement {
  return (
    <div className={styles.panel}>
      <h2 className={styles.title}>Trusted by</h2>
      <hr className={styles.hr} />
      <ul className={styles.list}>
        <li>
          <img src="/standard-life-logo.png" alt="" />
        </li>
        <li>
          <img src="/schroders-logo.png" alt="" />
        </li>
        <li>
          <img src="/studygroup-logo.png" alt="" />
        </li>
        <li>
          <img src="/now-pensions-logo.png" alt="" />
        </li>
      </ul>

      <h2 className={styles.title}>Built by</h2>
      <hr className={styles.hr} />
      <a
        href="https://www.mezzolabs.com/"
        target="_blank"
        className={styles.link}
        rel="noreferrer noopener"
      >
        <img src="/mezzo-logo.png" alt="" className={styles.logo} />
      </a>
      <p className={styles.agencyPar}>
        UK's largest independent web analytics consultancy.{' '}
      </p>

      <ul className={styles.secondList}>
        <li>
          <img src="/investors-in-people-white.png" alt="" />
        </li>
        <li>
          <img src="/cyber-essentials-logo.png" alt="" />
        </li>
        <li>
          <img src="/iso-logo.png" alt="" />
        </li>
      </ul>
      <p className={`${styles.par} ${styles.check}`}>
        GDPR and cyber security compliant
      </p>
    </div>
  )
}
